import React, { useContext } from "react"
import styled from "styled-components"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faExpandAlt, faCompressAlt } from "@fortawesome/free-solid-svg-icons"

import Card from "./Card"
import DropDownContext from "./DropDownContext"

const StyledCard = styled(Card)`
  padding: 5px 10px;
`

const HeaderLine = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;  
`

const CenteredLine = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 7px;
`

const GrayText = styled.span`
  color: var(--gray-text);
`

const BoldText = styled.span`
  font-weight: bold;
`

const SmallText = styled.span`
  font-size: var(--font-sub);
  line-height: var(--line-sub);
`

const TimeText = styled.span`
  color: var(--gray-text);
  font-size: var(--font-sub);
  line-height: var(--line-sub);
  text-transform: uppercase;
  font-weight: bold;
`

type RoleLineProps = {
  projectrole: String
  time: String
}

const RoleLine = ({projectrole,time}: RoleLineProps) => {
  return (
    <HeaderLine>
      <BoldText>{projectrole}</BoldText>
      <TimeText>{time}</TimeText>
    </HeaderLine>
  )
}

type NameLineProps = {
  name: string
  time: string
}

const NameLine = ({name,time}: NameLineProps ) => {
  return (
    <HeaderLine>
      <SmallText>{name}</SmallText>
      <SmallText>
        <GrayText>{time}</GrayText>
      </SmallText>
    </HeaderLine>
  )
}

const CompanyContainer = styled.span`
  display: flex;
  justify-content: left;
  align-items: center;
  gap: 2px;
`

const LogoContainer = styled.div`
  display: inline-block;
  height: 1.1rem;
  width: 1.1rem;
  overflow: hidden;
`

const StyledLogo = styled.img`
  width: 100%;
`

const CompanyName = styled.span`
  font-size: var(--font-sub);
  line-height: var(--line-sub);
`

const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--white);
`

const Icon = styled(FontAwesomeIcon)`
  color: var(--gray-text);
  opacity: 75%;
  user-select: none;
`

type CompanyLineProps = {
  logo: string
  companyname: string
  isDropped: boolean
}

const CompanyLine = ({logo, companyname, isDropped}: CompanyLineProps) => {
  return (
    <CenteredLine>
      <CompanyContainer>
        <LogoContainer>
          <StyledLogo src={logo} />
        </LogoContainer>
        <CompanyName>
          {companyname}
        </CompanyName>
      </CompanyContainer>
      <IconContainer>
        <Icon
          icon={isDropped ? faCompressAlt : faExpandAlt }
        />
      </IconContainer>
    </CenteredLine>
  )
}

type Props = {
  projectrole: string
  totaltime: string
  teamname: string
  startandend: string
  companylogo: string
  companyname: string
}

const CollapsableSkillHead = ({
  projectrole, totaltime, teamname,
  startandend, companylogo, companyname
}: Props) => {
  const { isDropped } = useContext(DropDownContext)

  return (
    <StyledCard>
      <RoleLine
        projectrole={projectrole}
        time={totaltime}/>
      <NameLine
        name={teamname}
        time={startandend}/>
      <CompanyLine
        logo={companylogo}
        companyname={companyname}
        isDropped={isDropped}/>
    </StyledCard>

      
  )
}

export default CollapsableSkillHead